import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../../ui';
import { SharedUiModule } from '../../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { CLAccountService } from './account.service';
import { CLAccountResolver } from './account.resolver';
import { CLAccountListComponent } from './account-list.component';
import { CLAccountEditComponent } from './account-edit.component';
import { CLAccountFilterDialogComponent } from './account-filter-dialog.component';
import { CLAccountDeletedComponent } from './account-deleted.component';
import { CLAccountSearchDialogComponent } from './account-search-dialog.component';

import { CLUserService } from './user.service';
import { CLUserResolver } from './user.resolver';
import { CLUserListComponent } from './user-list.component';
import { CLUserEditComponent } from './user-edit.component';
import { CLUserFilterDialogComponent } from './user-filter-dialog.component';
import { CLUserDeletedComponent } from './user-deleted.component';

import { CLUserRolePipe } from './user-role.pipe';
import { UserModule } from '../../user';
import { CLAccountUserListComponent } from './account-user-list.component';
import { SLEntityModule } from '../entity';
import { DLCompanyModule } from '../../documents-ledger/company';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    UserModule,
    SLEntityModule,
    DLCompanyModule,
  ],
  declarations: [
    CLAccountListComponent,
    CLAccountDeletedComponent,
    CLAccountEditComponent,
    CLAccountFilterDialogComponent,
    CLAccountSearchDialogComponent,
    
    CLUserListComponent,
    CLUserDeletedComponent,
    CLUserEditComponent,
    CLUserFilterDialogComponent,

    CLAccountUserListComponent,
    
    CLUserRolePipe,
  ],
  exports: [
    CLUserRolePipe,
  ],
  providers: [
    CLAccountService,
    CLAccountResolver,
    CLUserService,
    CLUserResolver,
  ],
  bootstrap: [
    CLAccountFilterDialogComponent,
    CLAccountSearchDialogComponent,
    CLUserFilterDialogComponent,
  ]
})
export class CLClientModule { }
